import * as React from 'react'
import Box from '@mui/material/Box'

export function LeadingIcon({ children }: { children: React.ReactNode }) {
  return (
    <Box
      sx={{
        flex: '0 0 auto',
        width: 48,
        height: 48,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& svg': { fontSize: 48 },
        '& img, & picture, & canvas': {
          width: 48,
          height: 48,
          objectFit: 'contain',
          display: 'block',
        },
      }}
    >
      {children}
    </Box>
  )
}
